/*
 * DeadlyScience newsletter pop-up extras (sections/overlay-newsletter.liquid).
 *
 * - "Show after time on site": counts how long the site has been open in a visible tab,
 *   across pages (localStorage), and opens the pop-up once it reaches the block's minutes.
 *   Waits if another dialog (e.g. the cultural warning) is open.
 * - "Days before showing again": after closing, the pop-up stays hidden for that many days
 *   (the theme's own cookie lasts 7).
 * - After any newsletter sign-up, the pop-up is hidden for a year and isn't reopened.
 */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var ACTIVE_KEY = 'dsActiveMs';
  var SUBSCRIBED_KEY = 'dsSubscribed';

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
    return value;
  }

  function hasCookie(name) {
    return document.cookie.split('; ').some(function (row) { return row.indexOf(name + '=') === 0; });
  }

  function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 86400000).toUTCString();
    // Same attributes as the theme's PopupCookie, so this replaces its 7-day cookie.
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; domain=' + window.location.hostname + '; sameSite=none; secure';
  }

  // ---------- Time on site ----------
  var activeMs = parseInt(store(ACTIVE_KEY) || '0', 10) || 0;
  var waiting = [];

  setInterval(function () {
    if (document.visibilityState !== 'visible') return;
    activeMs += 1000;
    store(ACTIVE_KEY, String(activeMs));
    for (var i = waiting.length - 1; i >= 0; i--) {
      if (activeMs >= waiting[i].ms && tryOpen(waiting[i])) waiting.splice(i, 1);
    }
  }, 1000);

  function tryOpen(entry) {
    var dialog = entry.dialog;
    if (hasCookie(entry.name)) return true; // closed in another tab
    var others = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < others.length; i++) {
      if (others[i] !== dialog) return false; // try again next second
    }
    if (entry.host && typeof entry.host.popupOpen === 'function') entry.host.popupOpen();
    return true;
  }

  function deviceMatches(dialog) {
    var isMobile = window.theme && typeof window.theme.isMobile === 'function' ? window.theme.isMobile() : window.innerWidth < 750;
    if (dialog.classList.contains('mobile') && !isMobile) return false;
    if (dialog.classList.contains('desktop') && isMobile) return false;
    return true;
  }

  function init() {
    var justSubscribed = window.location.search.indexOf('customer_posted=true') !== -1;
    if (justSubscribed) store(SUBSCRIBED_KEY, '1');
    var subscribed = store(SUBSCRIBED_KEY) === '1';

    var dialogs = document.querySelectorAll('popup-newsletter dialog[data-cookie-name]');
    for (var i = 0; i < dialogs.length; i++) {
      (function (dialog) {
        var host = dialog.closest('popup-newsletter');
        var name = dialog.getAttribute('data-cookie-name');
        var value = dialog.getAttribute('data-cookie-value') || 'user_has_closed';
        var days = parseInt(dialog.getAttribute('data-ds-days'), 10) || 7;
        var form = dialog.querySelector('form[data-newsletter-form], form.newsletter-form');

        // Longer wait after closing.
        var onClose = function () { setTimeout(function () { writeCookie(name, value, subscribed ? 365 : days); }, 0); };
        dialog.addEventListener('close', onClose);
        dialog.addEventListener('theme:popup:onclose', onClose);

        if (subscribed) {
          writeCookie(name, value, 365);
          // The theme reopens every pop-up after any sign-up; only keep it open if this
          // pop-up's own form was the one submitted (so its thank-you message shows).
          var ownSuccess = form && form.classList.contains('has-success');
          // dialog.close() fires "close", which the theme handles (unlocks scroll, focus etc.).
          if (!ownSuccess && dialog.open) dialog.close();
          return;
        }

        if (dialog.getAttribute('data-popup-delay') !== 'time_on_site') return;
        if (hasCookie(name) || !deviceMatches(dialog)) return;

        var minutes = parseInt(dialog.getAttribute('data-ds-minutes'), 10) || 2;
        var entry = { dialog: dialog, host: host, name: name, ms: minutes * 60000 };
        if (!(activeMs >= entry.ms && tryOpen(entry))) waiting.push(entry);
      })(dialogs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
